import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Header from './components/Header';
import HeroSection from './components/Hero';
import Privacy from './pages/Privacy';
import VerifyConsent from './pages/VerifyConsent';
import { UserProvider } from './components/UserContext';
import ConsentBanner from './components/ConsentBanner';
import { useEffect } from 'react';

function App() {
    const config = {
        "tenantId": "610b7a9c-72ea-11f0-998f-3e3dd1ad87e5",
        "siteId": "10852f98-6fb6-4d14-8f1d-59207d4f7108",
        "apiUrl": "https://api.dev-v5.privasapien.com/api"
    };
    useEffect(() => {
        window.addEventListener('saveCookies', handleSaveCookies);
        window.addEventListener('deleteAllCookies', handleRemoveAllCookies);
        return () => {
            window.removeEventListener("saveCookies", handleSaveCookies);
            window.removeEventListener("deleteAllCookies", handleRemoveAllCookies);
        };
    })

    function parseExpiryToDate(expiryString) {
        if (!expiryString || typeof expiryString !== 'string') {
            const d = new Date();
            d.setDate(d.getDate() + 30); // default 30 days
            return d;
        }
        const match = expiryString.trim().toLowerCase().match(/^(\d+)\s*(year|years|month|months|day|days|hour|hours|minute|minutes|second|seconds)$/);
        const n = match ? parseInt(match[1], 10) : 30;
        const unit = match ? match[2] : 'days';
        const d = new Date();
        switch (unit) {
            case 'year':
            case 'years':
                d.setFullYear(d.getFullYear() + n);
                break;
            case 'month':
            case 'months':
                d.setMonth(d.getMonth() + n);
                break;
            case 'day':
            case 'days':
                d.setDate(d.getDate() + n);
                break;
            case 'hour':
            case 'hours':
                d.setHours(d.getHours() + n);
                break;
            case 'minute':
            case 'minutes':
                d.setMinutes(d.getMinutes() + n);
                break;
            case 'second':
            case 'seconds':
                d.setSeconds(d.getSeconds() + n);
                break;
            default:
                d.setDate(d.getDate() + 30);
        }
        return d;
    }

    // Only apply Domain attribute if it matches the current host or its parent
    function getSafeDomainAttr(domain) {
        if (!domain) return '';
        const host = window.location.hostname.replace(/^\./, '');
        const dom = domain.replace(/^\./, '');
        if (host === dom || host.endsWith('.' + dom)) {
            return `; Domain=${dom}`;
            return '';
        }
    }

    function setCookie(name, value, { path = '/', domain, expiry, isHttp = false, isSecure = false } = {}) {
        const encoded = encodeURIComponent(String(value));
        const parts = [`${name}=${encoded}`];
        parts.push(`Path=${path}`);
        const domainAttr = getSafeDomainAttr(domain);
        if (domainAttr) parts.push(domainAttr.trim());
        const expDate = parseExpiryToDate(expiry);
        parts.push(`Expires=${expDate.toUTCString()}`);
        parts.push(`SameSite=Lax`);
        if (isSecure) {
            parts.push(`Secure`);
        }
        // Handle HttpOnly flag - Note: This won't work in client-side JavaScript
        // HttpOnly cookies can only be set by the server
        // if (isHttp) {
        // console.warn('HttpOnly flag cannot be set via JavaScript. This flag can only be set by the server.');
        // parts.push(`HttpOnly`); 
        // }

        document.cookie = parts.join('; ');
    }

    function deleteCookie(name, { path = '/', domain } = {}) {
        const parts = [`${name}=`, `Path=${path}`];
        const domainAttr = getSafeDomainAttr(domain);
        if (domainAttr) parts.push(domainAttr.trim());
        parts.push(`Expires=Thu, 01 Jan 1970 00:00:00 GMT`);
        parts.push(`SameSite=Lax`);
        if (window.location.protocol === 'https:') parts.push(`Secure`);
        document.cookie = parts.join('; ');
    }

    const handleSaveCookies = (event) => {
        console.log('DataLayer:', window.dataLayer);
        console.log('Save Event:', event.detail);
        const cookieStates = event?.detail?.cookieStates || {};
        Object.keys(cookieStates).forEach((categoryKey) => {
            const currentVendors = cookieStates[categoryKey]?.vendor || {};
            Object.keys(currentVendors).forEach((vendorKey) => {
                const vendorObj = currentVendors[vendorKey];
                const enabled = !!vendorObj?.enabled;
                const cookies = vendorObj?.cookies || {};

                Object.keys(cookies).forEach((cookieName) => {
                    const meta = cookies[cookieName] || {};
                    // console.log(meta)
                    // console.log('cookie: ', meta)
                    const opts = {
                        path: meta.path || '/',
                        domain: meta.domain,
                        expiry: meta.expiry || '1 year',
                        isHttp: meta.isHttp || false,
                        isSecure: meta.isSecure || false
                    };

                    if (enabled) {
                        // console.log(cookieName, opts)
                        setCookie(cookieName, 'dummy', opts);
                    } else {
                        deleteCookie(cookieName, opts);
                    }
                });
            });
        });
    };







    function buildPathCandidates(pathname = window.location.pathname) {
        const parts = pathname.split('/').filter(Boolean);
        const paths = [];
        for (let i = parts.length; i >= 1; i--) {
            paths.push('/' + parts.slice(0, i).join('/'));
        }
        paths.push('/'); // always include root
        // Deduplicate while preserving order
        return [...new Set(paths)];
    }

    // Build candidate domains: exact host and its parent domains (excluding public suffix is not trivial client-side)
    function buildDomainCandidates(hostname = window.location.hostname) {
        const segs = hostname.split('.').filter(Boolean);
        const domains = [];
        for (let i = 0; i < segs.length - 1; i++) {
            const d = segs.slice(i).join('.');
            domains.push(d);
        }
        // Include exact host explicitly
        if (!domains.includes(hostname)) domains.unshift(hostname);
        // Include dotted variants for legacy behavior (modern browsers ignore the leading dot)
        const withDots = domains.map(d => '.' + d);
        return [...new Set([...domains, ...withDots])];
    }

    // Delete cookie name with specific path/domain by expiring it in the past
    function deleteCookie(name, path = '/', domain) {
        const parts = [`${name}=`, `Expires=Thu, 01 Jan 1970 00:00:00 GMT`, `Path=${path}`];
        if (domain) parts.push(`Domain=${domain}`);
        if (window.location.protocol === 'https:') parts.push('Secure');
        // SameSite attribute is irrelevant for deletion, but allowed
        parts.push('SameSite=Lax');
        document.cookie = parts.join('; ');
    }

    // Remove all cookies visible to this document by trying common Path/Domain combinations
    const handleRemoveAllCookies = (_event) => {
        const cookieHeader = document.cookie || '';
        const names = cookieHeader
            .split(';')
            .map(kv => kv.split('=')[0].trim())
            .filter(Boolean);

        if (names.length === 0) return;

        const paths = buildPathCandidates();
        const domains = buildDomainCandidates();
        names.forEach((name) => {
            if(name!=='cookie-manager-preferences'){
                paths.forEach((p) => deleteCookie(name, p));
                domains.forEach((d) => {
                    paths.forEach((p) => deleteCookie(name, p, d));
                });
            }
        });
        console.log('DataLayer:', window.dataLayer);
    };


    return (
        <UserProvider>
            <Router>
                <Header />
                <Routes>
                    <Route path="/" element={<HeroSection />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/verify-consent" element={<VerifyConsent />} />
                    <Route path="/privacy" element={<Privacy />} />
                </Routes>
            </Router>
            <cookie-banner
                config={JSON.stringify(config)}
            />
            <ConsentBanner />
        </UserProvider>
    );
}

export default App;
